module.exports = __webpack_public_path__ + "img/9.f4dc23c9.jpg";